import PropTypes from "prop-types";
import { LeftOutlined, RightOutlined } from "@/config/antd";

const CustomPagination = ({
  current,
  total,
  pageSize,
  onChange,
  showTotal = true,
  className = "",
}) => {
  const totalPages = Math.ceil(total / pageSize);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      onChange(newPage);
    }
  };

  return (
    <div className={`flex items-center justify-between ${className}`}>
      {showTotal && (
        <span className="text-small text-darkGrey whitespace-nowrap">
          Showing {(current - 1) * pageSize + 1} -{" "}
          {Math.min(current * pageSize, total)} of {total} records
        </span>
      )}
      <div className="flex items-center space-x-4">
        <button
          onClick={() => handlePageChange(current - 1)}
          disabled={current === 1}
          className={`p-2 rounded-full ${
            current === 1
              ? "bg-secondary cursor-not-allowed opacity-50"
              : "bg-secondary hover:bg-gray-200 cursor-pointer"
          }`}
          aria-label="Previous page">
          <LeftOutlined className="text-primary" />
        </button>
        <span className="text-small bg-secondary p-2 rounded-lg text-darkGrey whitespace-nowrap">
          Page {current} of {totalPages}
        </span>
        <button
          onClick={() => handlePageChange(current + 1)}
          disabled={current === totalPages}
          className={`p-2 rounded-full ${
            current === totalPages
              ? "bg-secondary cursor-not-allowed opacity-50"
              : "bg-secondary hover:bg-gray-200 cursor-pointer"
          }`}
          aria-label="Next page">
          <RightOutlined className="text-primary" />
        </button>
      </div>
    </div>
  );
};

CustomPagination.propTypes = {
  current: PropTypes.number,
  total: PropTypes.number,
  pageSize: PropTypes.number,
  onChange: PropTypes.func,
  showTotal: PropTypes.bool,
  className: PropTypes.string,
};

export default CustomPagination;
